import { useState } from 'react'

import { replaceNotDigitToEmpty } from '@src/utils'

export const useHalfWidthDigitField = () => {
  const [displayDigit, setDigit] = useState('')

  function changeDisplayDigit(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    const value = event.target.value
    const halfWidthDigit = replaceNotDigitToEmpty(value)

    setDigit(halfWidthDigit)
  }

  return { displayDigit, setDigit, changeDisplayDigit }
}
